export const selectServiceCompanyOrder = (state) => state.serviceCompanyOrder;
export const selectServiceCompanyOrderLoading = (state) => state.serviceCompanyOrder?.loading;
export const selectServiceCompanyOrderDone = (state) => state.serviceCompanyOrder?.done;
export const selectServiceCompanyOrderError = (state) => state.serviceCompanyOrder?.error;
export const selectServiceCompanyOrderInfo = (state) => state.serviceCompanyOrder?.info;
